import { useCallback, useEffect, useRef } from 'react';

type UseDebounceOptions = {
  debounceTimeInMs: number;
};

type DebounceOptions = {
  debounceTimeInMs?: number;
};

export const useDebounce = ({
  debounceTimeInMs,
}: UseDebounceOptions): {
  debounce: (callback: Function, options?: DebounceOptions) => void;
} => {
  const debounceRef = useRef<ReturnType<typeof setTimeout>>(
    setTimeout(() => {}, 0),
  );

  const debounce = useCallback(
    (
      callback: Function,
      { debounceTimeInMs: localDebounceTimeInMs }: DebounceOptions = {},
    ): void => {
      clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
        callback();
      }, localDebounceTimeInMs ?? debounceTimeInMs);
    },
    [debounceTimeInMs],
  );

  useEffect(() => {
    return () => clearTimeout(debounceRef.current);
  }, []);

  return { debounce };
};
